import { toast } from 'sonner';
import type { TDatePickerEvaluationSummary } from 'types/evaluation.types';
import { EEvaluationType } from 'types/evaluation.types';
import { type TCalendarQuestion, hasKey, isDatePicker } from '@hubertai/screening-question-types';

const evaluateDatepicker = (question: TCalendarQuestion, _language: string, nodeEvaluation: any) => {
  const temp: TDatePickerEvaluationSummary = {
    id: question.id,
    evaluation: [],
    summary: {
      [EEvaluationType.Bonus]: 0,
      [EEvaluationType.Warning]: 0,
      [EEvaluationType.Disqualified]: 0,
      [EEvaluationType.Info]: 0,
      [EEvaluationType.Weighted]: 0,
    },
  };

  if (!question) {
    toast.error(`useQuestionEvaluation.evaluateDatepicker - question is not available.`);
    return;
  }

  if (!isDatePicker(question)) {
    toast.error(`useQuestionEvaluation.evaluateDatepicker - is not Datepicker v4.`);
  }

  if (nodeEvaluation && hasKey(nodeEvaluation, 'evaluation') && Array.isArray(nodeEvaluation.evaluation)) {
    nodeEvaluation.evaluation.map((detail: any) => {
      if (detail.name === EEvaluationType.Info) {
        temp.summary[EEvaluationType.Info] += 1;
      }

      if (detail.name === EEvaluationType.Warning) {
        temp.summary[EEvaluationType.Warning] += 1;
      }

      if (detail.name === EEvaluationType.Bonus) {
        temp.summary[EEvaluationType.Bonus] = Math.max(temp.summary[EEvaluationType.Bonus], detail.bonus_points ?? 0);
      }

      if (detail.name === EEvaluationType.Disqualified) {
        temp.summary[EEvaluationType.Disqualified] += 1;
      }
    });
  }

  return temp;
};

export default evaluateDatepicker;
